import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PaginatedListNavigation
  from '../../../paginatedlist/PaginatedListNavigation/PaginatedListNavigation';
import {
  refreshFilteredDeviceList,
  selectDeviceListColumnVisibility, selectDeviceListPageNo,
  selectDeviceListRowsPerPage, selectDeviceListTotalResults,
  setDeviceListColumnVisibility,
  setDeviceListPage,
  setDeviceListRowsPerPage,
} from '../../../../redux/slices/filteredDeviceListSlice/filteredDeviceListSlice';

/* istanbul ignore next */
function PaginatedDeviceListNavigation() {
  const alertListColumns = useSelector((state) => selectDeviceListColumnVisibility(state));
  const alertListNumRows = useSelector((state) => selectDeviceListRowsPerPage(state));
  const pageNo = useSelector((state) => selectDeviceListPageNo(state));
  const totalNumRecords = useSelector((state) => selectDeviceListTotalResults(state));
  const dispatch = useDispatch();
  return (
    <div>
      <PaginatedListNavigation
        columnVisibility={alertListColumns}
        currentPage={pageNo}
        onNextPage={() => {
          dispatch(setDeviceListPage(pageNo + 1));
          dispatch(refreshFilteredDeviceList());
        }}
        onPrevPage={() => {
          dispatch(setDeviceListPage(pageNo - 1));
          dispatch(refreshFilteredDeviceList());
        }}
        onToggleColumn={(name, visible) => dispatch(
          setDeviceListColumnVisibility({ columnName: name, visible }),
        )}
        totalResults={totalNumRecords}
        rowsPerPage={alertListNumRows}
        setRowsPerPage={(value) => {
          dispatch(setDeviceListRowsPerPage(value));
          dispatch(refreshFilteredDeviceList());
        }}
      />
    </div>
  );
}

export default PaginatedDeviceListNavigation;
